import React, { useEffect, useState, useRef } from "react";
import { setGlobalLoading } from "../context/LoaderController";
import { fetchMemberCount, fetchDistrictAssemblyCount } from "../services/api";
import Turnstile from "react-turnstile";
import {
  LOCALSTORAGE_SELECTED_STATE_CODE,
  LOCALSTORAGE_SELECTED_STATE_NAME,
  PAGE_TITLE_MEMBERSHIP_COUNT,
  NO_STATE_SELECTED_MESSAGE,
  LOADING_MEMBERSHIP_COUNT,
  ERROR_FETCH_MEMBER_COUNT,
  STATE_LABEL,
  MEMBER_COUNT_TOTAL_LABEL,
  MEMBER_COUNT_PAID_LABEL,
  MEMBER_COUNT_UNPAID_LABEL,
} from "../components/constants";
import "../App.css";

export default function MembershipCount() {
  const storedStateId = localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_CODE);
  const storedStateName =
    localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_NAME) || "";

  const [stateId] = useState(storedStateId ?? "");

  const [memberCountTotal, setMemberCountTotal] = useState(0);
  const [memberCountPaid, setMemberCountPaid] = useState(0);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [districtAssemblies, setDistrictAssemblies] = useState([]);
  const [showDA, setShowDA] = useState(false);
  const [daLoading, setDaLoading] = useState(false);

  const memberCountUnpaid = Math.max(memberCountTotal - memberCountPaid, 0);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [verifying, setVerifying] = useState(true);
//   const captchaRef = useRef(null);
  

  /* ================= LOAD MEMBER COUNTS FIRST ================= */
const loadCounts = async () => {
  if (!stateId) return;

  setGlobalLoading(true);
  setError("");

  try {
    const data = await fetchMemberCount(stateId);

    setMemberCountTotal(Number(data.memberCountTotal || 0));
    setMemberCountPaid(Number(data.memberCount || 0));

  } catch (err) {
    console.error(err);
    setError(ERROR_FETCH_MEMBER_COUNT);
  } finally {
    setGlobalLoading(false);
  }
};

useEffect(() => {
  if (!stateId) return;
  loadCounts();
}, [stateId]);

  /* ================= TOGGLE DISTRICT ASSEMBLY ================= */
  const handleToggleDistrictAssemblies = async () => {
    if (!stateId) return;

    if (!captchaToken) {
  setError("Verification in progress, please try again");
  return;
}

    // Hide if already visible
    if (showDA) {
      setShowDA(false);
      return;
    }

    // Show instantly if already fetched
    if (districtAssemblies.length > 0) {
      setShowDA(true);
      return;
    }

    // First-time fetch
    setDaLoading(true);
    setShowDA(true);

    try {
      const da = await fetchDistrictAssemblyCount(stateId, captchaToken);
      setDistrictAssemblies(Array.isArray(da) ? da : []);
//       // 👇 reset after success
// captchaRef.current?.reset();
// setCaptchaToken(null);
setCaptchaToken(null);
    } catch (err) {
      console.error(err);
      setDistrictAssemblies([]);
    } finally {
      setDaLoading(false);
    }
  };

  /* ================= NO STATE SELECTED ================= */
  if (!stateId) {
    return (
      <div className="main-container">
        <h2 className="section-title">{PAGE_TITLE_MEMBERSHIP_COUNT}</h2>
        <p>
          {NO_STATE_SELECTED_MESSAGE.split("Home")[0]}
          <a href="/" className="link">Home</a> page first.
        </p>
      </div>
    );
  }
return (
  <div className="main-container">

    {/* HEADER */}
    <div style={{ marginBottom: "24px" }}>
      <h2 className="section-title">{PAGE_TITLE_MEMBERSHIP_COUNT}</h2>

      <span className="iyc-badge">
        {STATE_LABEL} <strong>{storedStateName || stateId}</strong>
      </span>
    </div>

    {/* ================= ERROR ================= */}
    {error && (
      <div className="alert error">
        ❌ {error}
      </div>
    )}

    {/* ================= MEMBER SUMMARY ================= */}
    {!loading && !error && (
      <div className="card" style={{ marginTop: "24px" }}>
        <h3 className="card-title">Membership Overview</h3>

        <div className="votes-summary-container">
          <div className="votes-summary-box highlight">
            <div className="votes-summary-label">
              {MEMBER_COUNT_TOTAL_LABEL}
            </div>
            <div className="votes-summary-value">{memberCountTotal}</div>
          </div>

          <div className="votes-summary-box success">
            <div className="votes-summary-label">
              {MEMBER_COUNT_PAID_LABEL}
            </div>
            <div className="votes-summary-value">{memberCountPaid}</div>
          </div>

          <div className="votes-summary-box warning">
            <div className="votes-summary-label">
              {MEMBER_COUNT_UNPAID_LABEL}
            </div>
            <div className="votes-summary-value">{memberCountUnpaid}</div>
          </div>
        </div>
      </div>
    )}
{/* ================= DISTRICT SECTION ================= */}
<div className="card" style={{ marginTop: "24px" }}>
  
  <h3 className="card-title">District Assembly Member Count</h3>

  {/* CAPTCHA (only for district) */}
<div style={{ margin: "12px 0" }}>
<Turnstile
  sitekey="0x4AAAAAADGKVY6n8mkNgEJp"
  onVerify={(token) => {
    setCaptchaToken(token);
    setVerifying(false);   // 👈 important
    setError("");
  }}
  onExpire={() => {
    setCaptchaToken(null);
    setVerifying(true);    // 👈 important
    setDistrictAssemblies([]);
    setShowDA(false);
  }}
/>
</div>

  {/* BUTTON */}
  <div style={{ margin: "12px 0 16px 0" }}>
    <button
      className="iyc-primary-btn"
      onClick={handleToggleDistrictAssemblies}
      disabled={!captchaToken || daLoading || verifying}    >
      {daLoading
  ? "Verifying..."
  : daLoading
  ? "Loading..."
  : showDA
  ? "Hide District Data"
  : "Load District Assembly Member Count"}
    </button>
  </div>

  {/* CONTENT */}
  {showDA && (
    <>
      {daLoading && (
        <p className="muted-text">Loading district assembly data...</p>
      )}

      {!daLoading && districtAssemblies.length === 0 && (
        <p className="card-subtext">
          No district assembly data available.
        </p>
      )}

      {!daLoading && districtAssemblies.length > 0 && (
        <div className="table-container">
          <table className="common-table">
            <thead>
              <tr>
                <th>#</th>
                <th>District</th>
                <th>Assembly</th>
                <th>Members</th>
              </tr>
            </thead>
            <tbody>
              {districtAssemblies.map((row, i) => (
                <tr key={`${row.assemblyCode}-${i}`}>
                  <td>{i + 1}</td>
                  <td>{row.districtName}</td>
                  <td>{row.assemblyName}</td>
                  <td>{row.memberCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )}
</div>
  </div>
);
}
